import { Option } from './option.model';
import { StatusRequest } from './request-status.model';

export enum DEVICE_SIZE {
  MOBILE = `MOBILE`,
  TABLET = `TABLET`,
  DESKTOP = `DESKTOP`,
  WIDESCREEN = `WIDESCREEN`,
}

export const deviceSizeArray: string[] = Object.keys(DEVICE_SIZE)
  .filter(key => isNaN(Number(key)))
  .map(key => DEVICE_SIZE[key as keyof typeof DEVICE_SIZE]);

export interface OptionsRequest extends StatusRequest {
  options?: Option[];
}
